import BootstrapButton from "@/components/form/BootstrapButton"
import Icon from "@/components/Icon"
import { useLoading } from "@/composition/useLoading"
import type { ShipmentLog } from "@/models"
import { useLoggedInUser } from "@/stores/loggedInUserStore"
import usePopups from "@/stores/popupsStore"
import { PlainDate } from "@/temporal"
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { computed, ref } from "vue"
import { defineComponent, inferProps, ModalTitle, proxyProp, type ReactiveComponent } from "vue-utils"
import { canEditShipmentDate } from "../permissions"
import { useShipmentsStore } from "../store"

interface Props {
	shipment: ShipmentLog
}

const tdStyles = css`
	justify-content: space-between;
`

const ShipmentDateColumn: ReactiveComponent<Props> = (props) => {
	const popups = usePopups()
	const loggedInUser = useLoggedInUser()
	const store = useShipmentsStore()
	const { runAction } = useLoading()

	const shipment = proxyProp(props, "shipment")
	const canEdit = computed(() => canEditShipmentDate({ loggedInUser, tfs: store.tfs, shipment: props.shipment }))

	async function setDate() {
		const date = ref(shipment.shipmentDate?.toJSON() ?? "")
		const result = await popups.confirm(() => (
			<>
				<ModalTitle title="Enter Shipment Date" />
				<hr />
				<input type="date" v-model={date.value} required />
			</>
		))
		if (result) {
			await runAction(store.editShipmentDate(shipment.id, PlainDate.from(date.value)))
		}
	}

	return () => (
		<td class={tdStyles}>
			<span>{shipment.shipmentDate?.toGBString() ?? "N/A"}</span>
			{canEdit.value && (
				<BootstrapButton
					color={shipment.shipmentDate ? "primary" : "success"}
					onClick={() => void setDate()}
					title="Click to Edit Date"
				>
					<Icon icon={shipment.shipmentDate ? faEdit : faPlus} />
				</BootstrapButton>
			)}
		</td>
	)
}

export default defineComponent(ShipmentDateColumn, inferProps<Props>())
